export type VariantAttributePair = {
  attributeId: string;
  value: string;
};

export function buildVariantCombinationKey(
  variantAttributes: VariantAttributePair[],
): string {
  return [...variantAttributes]
    .sort((a, b) => a.attributeId.localeCompare(b.attributeId))
    .map((item) => `${item.attributeId}:${item.value.trim().toLowerCase()}`)
    .join("|");
}
